import React from "react";
import { Avatar } from "@progress/kendo-react-layout";
import defaultAvatar from "../../assets/Images/useravatar.jpg";

interface ListingAvatarProps {
  src?: string;
  alt?: string;
  fallbackText?: string;
  size?: number | string;
  backgroundColor?: string;
  className?: string;
}

const ListingAvatar: React.FC<ListingAvatarProps> = ({
  src,
  alt = "Avatar",
  fallbackText = "",
  size = 40,
  backgroundColor = "#174583",
  className,
}) => {
  const [isImgLoaded, setIsImgLoaded] = React.useState(false);
  const [imgError, setImgError] = React.useState(false);

  React.useEffect(() => {
    setIsImgLoaded(false);
    setImgError(false);
  }, [src]);

  const hasImage = src && src.trim() !== "" && !imgError;
  const showMainImage = hasImage && isImgLoaded;

  return (
    <Avatar
      style={{
        width: size,
        height: size,
        backgroundColor: showMainImage ? "transparent" : backgroundColor,
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        fontWeight: "bold",
        fontSize: typeof size === "number" ? size * 0.35 : "14px",
      }}
      className={className}
      type={!showMainImage && fallbackText ? "text" : "image"}
    >
      {hasImage && (
        <img
          src={src}
          alt={alt}
          onLoad={() => setIsImgLoaded(true)}
          onError={() => setImgError(true)}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
            display: isImgLoaded ? "block" : "none",
          }}
        />
      )}

      {(!hasImage || !isImgLoaded) && (
        fallbackText ? (
          <span
            className="userprofile-avatar-text"
            style={{
              lineHeight: 1,
              userSelect: "none",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {fallbackText}
          </span>
        ) : (
          <img
            src={defaultAvatar}
            alt="default-avatar"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        )
      )}
    </Avatar>
  );
};

export default ListingAvatar;
